import { connect } from 'react-redux';
import { withHandlers, withState, compose, pure } from 'recompose';

import { handleAddRequestAssignee, handleRemoveRequestAssignee } from '../../redux/thunk/requests';
import { ManageAssignees } from '../../components/requests-list-item/request-header/request-assignees/manage-assignees';


export default compose(
  connect(
    ({ tasks }) => ({ tasks: tasks && tasks.items }),
    {
      handleAddRequestAssignee,
      handleRemoveRequestAssignee,
    },
  ),
  pure,
  withState('showSearch', 'setShowSearch', false),
  withState('isSalesPopVisible', 'setIsSalesPopVisible', false),
  withHandlers({
    onAddAssignee: ({ requestId, ...actions }) => assigneeId =>
      actions.handleAddRequestAssignee(requestId, assigneeId),
    onRemoveAssignee: ({ requestId, ...actions }) => assigneeId =>
      actions.handleRemoveRequestAssignee(requestId, assigneeId),
  }),
)(ManageAssignees);



// WEBPACK FOOTER //
// ./src/containers/requests-list-item/request-assignees.js